export function Sum(...numbers: Array<number | undefined>) {
  const sum = numbers.reduce((a, b) => (a || 0) + (b || 0), 0)
  return isNaN(sum as number) ? 0 : sum
}
